export default "__VITE_ASSET__CAQuN4HQ__"